// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionButton_openModalButton__yH6\\+n {
    background-color: var(--buttonYellow);
    border: none;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    padding: 10px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.ActionButton_openModalButton__yH6\\+n:hover {
    background-color: #b58803;
}

.ActionButton_openModalButton__yH6\\+n:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/Buttons/ActionButton.module.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":[".openModalButton {\n    background-color: var(--buttonYellow);\n    border: none;\n    color: #fff;\n    font-weight: bold;\n    font-size: 16px;\n    padding: 10px 20px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.openModalButton:hover {\n    background-color: #b58803;\n}\n\n.openModalButton:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"openModalButton": `ActionButton_openModalButton__yH6+n`
};
export default ___CSS_LOADER_EXPORT___;
